<template>
  <div id="app">
    <Header></Header>
    <router-view class="content"/>
    <Footer></Footer>
    <SideTools></SideTools>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.content{
  margin-top: 110px;
}
body {
  width: 100%;
  height: 100%;
  overflow-y: scroll; /* 假设您只希望有垂直滚动条 */
  margin: 0;
}

/* 自定义滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px; /* 这里设置滚动条的宽度 */
}

/* 自定义滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.3); /* 轨道颜色 */
}

/* 自定义滚动条拇指 */
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3); /* 拇指颜色 */
  border-radius: 4px; /* 拇指圆角 */
  /* 可选：添加拇指悬停时的样式 */
  /* &:hover {
     background-color: rgba(0, 0, 0, 0.7);
   } */
}
</style>



// WEBPACK FOOTER //
// src/App.vue